import React, { useState, useEffect } from "react";
import {
  Card,
  CardHeader,
  ListGroup,
  ListGroupItem,
  Row,
  Col,
  Form,
  FormInput,
  Button,
} from "shards-react";
import DatePicker from "react-datepicker";
import updateInvoices from "../../hooks/updateInvoices";


export default function AddInvoiceCard({ docs, selectedUser }) {
  const [invoices, setInvoices] = useState(null)

  useEffect(() => {
    setInvoices(selectedUser && docs.filter(doc => { return doc.id === selectedUser.id })[0].invoices)
  }, [docs, selectedUser])

  const [startDate, setStartDate] = useState(new Date());
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(null);
  const [invoiceId, setInvoiceId] = useState(null);

  async function handleAddInvoice(e) {
    e.preventDefault()

    try {
      setError('');
      setLoading(true);
      const currentInvoices = invoices
      currentInvoices.map(invoice => {
        if (invoice.invoice_id === invoiceId) {
          throw ('This invoice already exists')
        }
        return invoices
      })
      const invoice = { invoice_id: invoiceId, invoice_date: startDate }
      currentInvoices.push(invoice)

      updateInvoices(selectedUser.id, currentInvoices)
      setInvoiceId('')
      setStartDate('')
    } catch (err) {
      setError(err)
    }
    setLoading(false);

  }
  return (
    <Card small className="mb-4">
      <CardHeader className="border-bottom">
        <h6 className="m-0">Add Invoice</h6>
      </CardHeader>
      <ListGroup flush>
        <ListGroupItem className="p-3">
          <Row>
            <Col>
              <Form onSubmit={handleAddInvoice}>
                <Row form>
                  {/* Invoice ID*/}
                  <Col md="12" className="form-group">
                    <label>Invoice ID</label>
                    <FormInput
                      disabled={!selectedUser}
                      required
                      placeholder="Enter Invoice ID"
                      value={invoiceId}
                      onChange={e => { setInvoiceId(e.target.value) }}
                    />
                  </Col>
                  {/* Invoice Date */}
                  <Col md="12" className="form-group">
                    <label className="d-flex">Invoice Due Date</label>
                    <DatePicker
                      disabled={!selectedUser}
                      className="form-control"
                      selected={startDate}
                      onChange={(date) => setStartDate(date)}
                      required
                      placeholder="Due Date"
                    />
                  </Col>

                  <Col md="12" className="form-group">
                    <Button type="submit" disabled={loading || !selectedUser || !invoiceId || !startDate} className="d-flex" theme="primary">Add Invoice</Button>
                  </Col>
                  {error && error}
                </Row>
              </Form>
            </Col>
          </Row>
        </ListGroupItem>
      </ListGroup>
    </Card>
  )
}
